import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm } from 'redux-form'

import validate from './validate'
import Input from 'components/atoms/inputs/generic_input'
import RoundedButton from 'components/atoms/buttons/solid'
import iconName from 'components/atoms/images/icono_nombre_apellido.svg'
import iconArtistName from 'components/atoms/images/icono_artista.svg'
import iconEmail from 'components/atoms/images/icono_correo.svg'
import iconPassword from 'components/atoms/images/icono_contrasenia.svg'
import iconTel from 'components/atoms/images/icono_telefono_formulario.svg'
import iconRFC from 'components/atoms/images/icono_rfc.svg'

class WizardFormFirstPage extends Component {

  render(){
    const { handleSubmit } = this.props

    return (
      <>
        <h2 className='text-primary mt-4'>Bienvenido a Muzigzag</h2>
        <p>Por favor ingresa tus datos personales.</p>
        <form onSubmit={handleSubmit} className='p-2'>
          <div className={"d-flex flex-row align-items-center justify-content-between"}>
            <Field
                name="name"
                type="text"
                placeholder="Nombre*"
                autocomplete='name'
                icon={iconName}
                component={Input}
            />
            <Field
                name="lastName"
                type="text"
                placeholder="Apellidos*"
                autocomplete='last-name'
                icon={iconName}
                component={Input}
            />
          </div>
          <div className={"d-flex flex-row align-items-center justify-content-between"}>
            <Field
                name="artistName"
                type="text"
                placeholder="Nombre artístico*"
                autocomplete='artist-name'
                icon={iconArtistName}
                component={Input}
            />
            <Field
                name="rfc"
                type="text"
                placeholder="RFC/ Número Fiscal o Tributario"
                autocomplete='artist-rfc'
                icon={iconRFC}
                component={Input}
            />
          </div>
          <Field
            name="email"
            type="email"
            placeholder="Correo electrónico*"
            autocomplete='email'
            icon={iconEmail}
            component={Input}
          />
          <div className={"d-flex flex-row align-items-center justify-content-between"}>
            <Field
                name="password"
                type="password"
                placeholder="Contraseña*"
                autocomplete='password'
                icon={iconPassword}
                component={Input}
            />
            <Field
                name="confirmPassword"
                type="password"
                placeholder="Confirmar contraseña*"
                autocomplete='confirm-password'
                icon={iconPassword}
                component={Input}
            />
          </div>
          <div className={"d-flex flex-row align-items-center justify-content-between"}>
            <Field
                name="tel"
                type='number'
                placeholder="Teléfono principal*"
                autocomplete='main-tel'
                icon={iconTel}
                component={Input}
            />
            <Field
                name="telSecondary"
                type='number'
                placeholder="Teléfono secundario"
                autocomplete='secondary-tel'
                icon={iconTel}
                component={Input}
            />
          </div>

          <div className="py-1"/>
          <p style={{fontSize: "12px"}} className='text-gray'>*Campos obligatorios</p>
          <div className="py-3"/>
          
          <div className='d-flex justify-content-center mt-5'>
            <RoundedButton type="submit" text='Siguiente'/>
          </div>
        </form>
      </>
    )
  }
}


WizardFormFirstPage = reduxForm({
  form: 'signupArtistWizard', // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  validate,
})(WizardFormFirstPage)

WizardFormFirstPage = connect(
  null,
  { }
)(WizardFormFirstPage)

export default WizardFormFirstPage